import {LABELS} from '@github-ui/issues-shared/labels'
import {SoftNavOnlyLink as Link, useParams} from '@github-ui/react-router'
import {RepoIssuesPageLayout} from '@github-ui/repo-issues-page-layout/RepoIssuesPageLayout'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
import {ViewsIndexContent} from '@github-ui/saved-views/components/index/ViewsIndexContent'
import {Button} from '@primer/react'
import {useEffect} from 'react'

import {renderIssuesSidebar} from '../components/sidebar/render-issues-sidebar'
import {BUTTON_LABELS} from '../constants/buttons'
import {useSavedViews} from '../hooks/use-saved-views'
import {
  IssueIndexPage,
  IssueShowPage,
  RepositoryMilestonePage,
  RepositorySavedViewPage,
  RepositoryViewNewPage,
} from '../lazy-routes'
import {preloadWhenIdle} from '../utils/preload-when-idle'
import {AnalyticsWrapper} from './AnalyticsWrapper'

export function IssueViewsPage() {
  const {owner = '', repo = ''} = useParams<{owner: string; repo: string}>()
  const sidebarLayoutEnabled = useRepoIssuesSidebarLayoutEnabled()

  const {showCreateAction, serverViews} = useSavedViews({owner, repo, enabled: sidebarLayoutEnabled})

  useEffect(() => {
    return preloadWhenIdle(() => {
      IssueIndexPage.preload()
      IssueShowPage.preload()
      RepositoryMilestonePage.preload()
      RepositorySavedViewPage.preload()
      RepositoryViewNewPage.preload()
    })
  }, [])

  const newViewUrl = `/${owner}/${repo}/issues/views/new`
  const headerActions = showCreateAction ? (
    <Button as={Link} to={newViewUrl} variant="primary">
      {BUTTON_LABELS.newView}
    </Button>
  ) : undefined

  return (
    <RepoIssuesPageLayout
      title={LABELS.viewsTitle}
      dialogTitle={LABELS.viewsTitle}
      actions={headerActions}
      renderSidebar={renderIssuesSidebar}
    >
      <AnalyticsWrapper category="Repository Saved Views Index">
        <ViewsIndexContent newViewUrl={newViewUrl} initialData={serverViews} />
      </AnalyticsWrapper>
    </RepoIssuesPageLayout>
  )
}
